import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-brand-plp-loading',
  templateUrl: './brand-plp-loading.component.html',
  styleUrls: ['./brand-plp-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandPlpLoadingComponent {
  @Input() isLandScapeTablet: boolean;
  @Input() isDesktop: boolean;
  @Input() isTablet: boolean;
  @Input() isMobile: boolean;
}
